import React,{useEffect,useRef,useState} from 'react';
import api from '../api';

const message=e=>typeof e?.response?.data?.detail==='string'?e.response.data.detail:'Не удалось выполнить операцию. Прежние данные сохранены.';
const monthLabel=value=>new Date(value+'-01T12:00:00Z').toLocaleDateString('ru-RU',{month:'long',year:'numeric',timeZone:'UTC'});
const stamp=value=>new Date(value).toLocaleString('ru-RU',{timeZone:'Europe/Moscow'});

export function SectionRebuildFreshness({rows=[],month}){
  const selected=rows.filter(r=>!month||r.month===month);
  if(!selected.length)return null;
  return <details className="section-rebuild-freshness"><summary>Разделы пересобраны отдельно · {selected.length}</summary>
    <p>Общая граница догрузки сохранена. Пересбор обновил только перечисленные месяцы и разделы.</p>
    <ul>{selected.map(r=><li key={`${r.month}:${r.family}`}>{monthLabel(r.month)} · {({trade:'Продажи и прибыльность',manager_trade:'Продажи группы',receipts:'Приёмки',writeoffs:'Списания и возвраты',preorders:'Предзаказы',balances:'Взаиморасчёты'})[r.family]||r.family}: данные на {stamp(r.source_fact_at)} МСК; публикация {stamp(r.published_at)} МСК.</li>)}</ul>
  </details>;
}

export default function DashboardRebuildControls({kind,panelId,onComplete,beforeStart,disabled=false}){
  const [open,setOpen]=useState(false),[catalog,setCatalog]=useState(null),[error,setError]=useState('');
  const [sections,setSections]=useState([]),[from,setFrom]=useState(''),[to,setTo]=useState('');
  const [preview,setPreview]=useState(null),[busy,setBusy]=useState(false),[job,setJob]=useState(null);
  const complete=useRef(onComplete);complete.current=onComplete;
  const endpoint=`/tenant/dashboard-rebuild/${kind}`,params={panel_id:panelId};
  useEffect(()=>{
    if(!open)return undefined;
    let active=true;setError('');setCatalog(null);setPreview(null);
    api.get(`${endpoint}/catalog`,{params:{panel_id:panelId}}).then(({data})=>{
      if(!active)return;
      setCatalog(data);setSections([]);setJob(data.job);
      const month=data.months.includes(data.current_month)?data.current_month:data.months.at(-1)||'';
      setFrom(month);setTo(month);
    }).catch(e=>{if(active)setError(message(e));});
    return()=>{active=false;};
  },[open,endpoint,panelId]);
  const running=['queued','running'].includes(job?.status);
  useEffect(()=>{
    if(!running)return undefined;
    let active=true;
    const timer=setInterval(async()=>{
      try{
        const {data}=await api.get(`${endpoint}/jobs/${job.id}`,{params:{panel_id:panelId}});
        if(!active)return;setJob(data);
        if(data.status==='success'){setPreview(null);complete.current?.();}
        if(data.status==='failed')setError(data.error||'Пересбор не выполнен. Прежние данные сохранены.');
      }catch(e){if(active)setError(message(e));}
    },3000);
    return()=>{active=false;clearInterval(timer);};
  },[running,job?.id,endpoint,panelId]);
  const change=fn=>value=>{fn(value);setPreview(null);setError('');};
  async function prepare(){
    setBusy(true);setError('');
    try{const {data}=await api.post(`${endpoint}/plan`,{sections,from_month:from,to_month:to},{params});setPreview(data);}
    catch(e){setError(message(e));}finally{setBusy(false);}
  }
  async function start(){
    setBusy(true);setError('');
    try{
      await beforeStart?.();
      const {data}=await api.post(`${endpoint}/start`,{sections,from_month:from,to_month:to,plan_sha256:preview.plan_sha256},{params});
      setJob(data.job);setPreview(null);
    }catch(e){setError(message(e));}finally{setBusy(false);}
  }
  return <div className="dashboard-rebuild-controls">
    <button type="button" aria-expanded={open} disabled={disabled} onClick={()=>setOpen(v=>!v)}>Настроить обновление</button>
    {open&&<section className="workspace-card rebuild-editor" aria-label="Пересбор выбранных разделов">
      <h2>Пересобрать разделы за период</h2>
      <p>Обычная догрузка и расписание продолжают работать отдельно. Здесь источник перечитывается только за выбранные месяцы; недельные сводки не меняются.</p>
      {error&&<p role="alert" className="workspace-alert">{error}</p>}
      {!catalog&&!error&&<p role="status">Получаем доступные разделы…</p>}
      {catalog&&<>
        <fieldset disabled={busy||running}><legend>Разделы</legend><div className="rebuild-sections">
          {catalog.sections.map(s=><label key={s.key} title={s.reason||''}>
            <input type="checkbox" disabled={!s.enabled} checked={sections.includes(s.key)} onChange={e=>change(setSections)(e.target.checked?[...sections,s.key]:sections.filter(k=>k!==s.key))}/>
            <span>{s.label}{!s.enabled&&<small>{s.reason}</small>}</span>
          </label>)}
        </div></fieldset>
        <div className="rebuild-months"><label>С месяца<select value={from} disabled={busy||running} onChange={e=>change(setFrom)(e.target.value)}>{catalog.months.map(m=><option key={m} value={m}>{monthLabel(m)}</option>)}</select></label>
          <label>По месяц включительно<select value={to} disabled={busy||running} onChange={e=>change(setTo)(e.target.value)}>{catalog.months.map(m=><option key={m} value={m}>{monthLabel(m)}</option>)}</select></label>
          <button type="button" disabled={busy||running||!sections.length||!from||!to} onClick={prepare}>Проверить план</button>
        </div>
        {preview&&<div className="rebuild-plan" role="status"><strong>{monthLabel(from)} — {monthLabel(to)}</strong>
          <p>Будут обновлены: {catalog.sections.filter(s=>preview.parameters.affected_sections.includes(s.key)).map(s=>s.label).join(', ')}.</p>
          <ul>{preview.parameters.notes.map(note=><li key={note}>{note}</li>)}</ul>
          <button type="button" className="workspace-primary" disabled={busy||running} onClick={start}>Запустить пересбор выбранного периода</button>
        </div>}
        {running&&<p role="status">{job.status==='queued'?'Ожидает запуска':'Выполняется на сервере'}. Можно закрыть эту настройку: работа продолжится. Прежний проверенный снимок доступен до завершения.</p>}
        {running&&job.target&&<p>{job.target.months.map(monthLabel).join(', ')} · {catalog.sections.filter(s=>job.target.sections.includes(s.key)).map(s=>s.label).join(', ')}</p>}
        {job?.status==='success'&&<p role="status">Последнее обновление завершено. Даты отдельно пересобранных разделов указаны над показателями.</p>}
        {job?.status==='failed'&&!error&&<p role="alert">{job.error||'Прежние данные сохранены.'}</p>}
      </>}
    </section>}
  </div>;
}
